import { formatMovement } from '@/lib/chart';
import { cn } from '@/lib/cn';

const TONE = { up: 'text-up', down: 'text-down', none: 'text-faint' } as const;

interface ChartMovementProps {
  /** Places gained since last week; negative fell, null did not chart then. */
  movement: number | null;
  className?: string;
}

/** Movement since last week: green riser, flame faller, faint em dash. */
export function ChartMovement({ movement, className }: ChartMovementProps) {
  const { label, tone } = formatMovement(movement);
  return <span className={cn('font-mono text-xs', TONE[tone], className)}>{label}</span>;
}
